export const seatCountTranslation = {
    wordEnding(seatNum: Number): String {
        const numString = seatNum.toString();

        if (numString[numString.length - 1] === '1') {
            return 'seat';
        }
        if (numString[0] === '1') {
            return 'seats-1';
        }
        if (numString[numString.length - 1] === '0') {
            return 'seats-1';
        }
        return 'seats';
    }
}

// export default function wordEnding(seatNum: Number): String {
//     const numString = seatNum.toString();
//
//         if (numString[numString.length - 1] === '1') {
//             return 'seat';
//         }
//         if (numString[0] === '1') {
//             return 'seats-1';
//         }
//         if (numString[numString.length - 1] === '0') {
//             return 'seats-1';
//         }
//         return 'seats';
//     }
